import { GenerateRecord, type RecordStage } from "@hg/recall-frame"
import { type Dispatch, forwardRef, useImperativeHandle, useRef } from "react"

import StrokeText from "@/components/StrokeText"
import { i18n } from "@/i18n"
import { Encode } from "./Encode"
import { Reward } from "./Reward"

import styles from "./index.module.scss"

const AWARD_TITLE = i18n.getRecall("record.switcher_award") || "-"
const ENCODE_TITLE = i18n.getRecall("record.switcher_encode") || "-"

interface SwitcherProps {
    current: RecordStage
    setCurrent: Dispatch<RecordStage>
}

const Switcher = forwardRef<SwitcherRef, SwitcherProps>(
    ({ current, setCurrent }, ref) => {
        useImperativeHandle(ref, () => ({ setCurrent }))

        return (
            <>
                <div className={styles.switcher} data-type={current}>
                    <div
                        className={styles.label}
                        onClick={() => setCurrent("award")}
                    >
                        <StrokeText
                            text={AWARD_TITLE}
                            fontFamily="source-han-sans-japanese"
                            fontWeight={700}
                            fontSize={40}
                            fillColor="#ffffff"
                            borderWidth={3}
                            borderColor="#614518"
                            offsetY={0}
                            padding={3}
                            baselineAligned
                        />
                    </div>
                    <div
                        className={styles.label}
                        onClick={() => setCurrent("encode")}
                    >
                        <StrokeText
                            text={ENCODE_TITLE}
                            fontFamily="source-han-sans-japanese"
                            fontWeight={700}
                            fontSize={32}
                            fillColor="#ffffff"
                            borderWidth={3}
                            borderColor="#614518"
                            offsetY={0}
                            padding={3}
                            baselineAligned
                        />
                    </div>
                </div>
                <div className={styles.divider} />
            </>
        )
    },
)

interface SwitcherRef {
    setCurrent: Dispatch<RecordStage>
}

export const Record: React.FC = () => {
    const switcherRef = useRef<SwitcherRef | null>(null)

    return (
        <GenerateRecord
            wrapperCls={styles.record}
            headerCls={styles.header}
            contentCls={styles.content}
            renderSwitcher={(props) => (
                <Switcher ref={switcherRef} {...props} />
            )}
            renderAward={() => <Reward />}
            renderEncode={() => <Encode switcherRef={switcherRef} />}
        />
    )
}

export default Record
